import React from "react";
import ContactForm from "./ContactForm";
import TabLayout from "../../../../helpers/TabLayout";
import { contactCreate } from "../../../../../api/contact";

const contactCreateAction = async ({ request }) => {
  const formData = await request.formData();

  const submission = {
    useSessionInfo: formData.get("useSessionInfo") === "true",
    request: formData.get("request"),
    status: formData.get("status"),
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    longDescription: formData.get("longDescription"),
  };

  return await contactCreate({ ...submission });
};

const ContactCreateForm = () => (
  <TabLayout headerLabel="Create New Contact">
    <ContactForm contact={null}/>
  </TabLayout>
);

export { contactCreateAction };
export default ContactCreateForm;